import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 2.83301H0.5C0.223958 2.83301 0 3.05697 0 3.33301C0 3.60905 0.223958 3.83301 0.5 3.83301H4.5C4.77604 3.83301 5 3.60905 5 3.33301C5 3.05697 4.77604 2.83301 4.5 2.83301Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 7.83301H3.16667C3.44271 7.83301 3.66667 7.60905 3.66667 7.33301C3.66667 7.05697 3.44271 6.83301 3.16667 6.83301H0.5C0.223958 6.83301 0 7.05697 0 7.33301C0 7.60905 0.223958 7.83301 0.5 7.83301Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 10.833H0.5C0.223958 10.833 0 11.057 0 11.333C0 11.609 0.223958 11.833 0.5 11.833H4.5C4.77604 11.833 5 11.609 5 11.333C5 11.057 4.77604 10.833 4.5 10.833Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6259 10.2223L15.023 7.82508C15.2526 7.59002 15.2548 7.21299 15.0225 6.97516L12.6259 4.5785C12.3885 4.34101 12.0034 4.34104 11.7659 4.5785C11.5284 4.81597 11.5284 5.20102 11.7659 5.43851L13.1197 6.79228H7.6081C7.27225 6.79228 7 7.06452 7 7.40038C7 7.73624 7.27225 8.00849 7.6081 8.00849H13.1197L11.7659 9.36228C11.5284 9.59974 11.5284 9.9848 11.7659 10.2223C12.0033 10.4597 12.3884 10.4598 12.6259 10.2223Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgExpand);
export default ForwardRef;
